module.exports = __webpack_public_path__ + "static/img/payment-fourth-1x.963ceae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/payment-fourth-1x.png
// module id = y6tf
// module chunks = 12